import React from "react";
import {BudgetDayBar} from "./day_bars/BudgetDayBar";
import {DashboardBarsCell} from "./DashboardBarsCell";

export class DashboardFullPeriodBudgetProportionalCell extends DashboardBarsCell {

    renderDayBar(dayNumber, alertLevel, alertData, isToday, alert_snoozed, rowType) {
        return <BudgetDayBar key={dayNumber}
                             dayNumber={dayNumber + 1}
                             alertLevel={alertLevel}
                             fluctuation={alertData.fluctuation}
                             fluctuationPercentage={alertData.fluctuation_percentage}
                             spentOnDay={alertData.formatted_value}
                             expectedSpentOnDay={alertData.formatted_total_budget}
                             budgetPartialGoalAllocatedBudget={alertData.formatted_budget_partial_goal_allocated_budget}
                             budgetPartialGoalDate={alertData.budget_partial_goal_date}
                             rollover={alertData.rollover}
                             balance={alertData.balance}
                             allocatedBudget={alertData.formatted_allocated_budget}
                             isToday={isToday}
                             isSnoozed={this.props.data.alert_snoozed}
                             rowType={rowType}
        />;
    }


    render() {
        if(this._shouldRenderEmptyCell()) {
            return (
                <td className={`graphic-data ${this.processingCssClasses()}`}>
                    <div className="graphic-budget">
                        &nbsp;
                    </div>
                </td>
            );
        }

        let pastAndTodayBars = this.barsForPastDaysAndToday();
        const budgetBars = this.addFutureDaysBars(pastAndTodayBars);

        return (
            <td className={`graphic-data ${this.processingCssClasses()}`}>
                <div className="graphic-budget">
                    {this.renderWarningIfNecessary()}
                    {budgetBars}
                </div>
            </td>
        );
    }
}
